import Api from '../../services/Api';

export default {
  state: {
    productsEssilor: [],
    productsEssilorLoaded: false,
  },
  actions: {
    loadProductsEssilor({ commit }) {
      Api.getProduct()
        .then(r => r.data)
        .then(values => {
          commit('SET_PRODUCTESSILOR', values);
        })
        .catch(error => {
          this.$log.error(error);
        });
    },
  },
  mutations: {
    SET_PRODUCTESSILOR(state, values) {
      state.productsEssilor = values;
      state.productsEssilorLoaded = true;
    },
  },
  getters: {
    productsEssilorByCategory: state => category => {
      return state.productsEssilor.filter(product =>
        product
          ? product.category ===
            category /* TODO ALE : filtrer au niveau du Range ?  &&
          state.ranges.find(range => range.id === product.rangeId).isActive*/
          : false
      );
    },
    isProductEssilorLoaded: state => () => {
      return state.productsEssilorLoaded;
    },
  },
};
